import axios from 'axios';

class HttpRequest {
    constructor(options) {
        this.defaults = {
            baseURL: '',
        }
        this.defaults = Object.assign(this.defaults, options);
    }

    setConfig() {

    }

    interceptors(install) {
        install.interceptors.request.use(
            config => {
                let token = localStorage.getItem('token');
                if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            err => {
                return Promise.reject(err);
            }
        );
        install.interceptors.response.use(
            res => {
                const { data } = res;
                return data;
            },
            err => {
                return Promise.reject(err);
            }
        );
    }

    request(options) {
        options = Object.assign(this.defaults, options)
        const instance = axios.create(options)
        this.interceptors(instance);
        return instance
    }
}

const request = new HttpRequest({
    baseURL: process.env.VUE_APP_BASE_URL + '/api'
});

const http = request.request();

// 获取头部导航
export async function getTopMenu() {
    return await http.get('/veteran/vs/link-config/list');
}

// 获取banner数据
export async function getBanner() {
    return await http.post('/veteran/vs/banner/list');
}

/**
 * 0新闻信息、1公告信息、2公示信息、3办事指南、4政策法规 无分页，只返回前10条
 * @export
 * @param {string} [params.beginCreateTime] - 开始创建时间
 * @param {string} [params.beginPushTime] - 开始发布时间
 * @param {string} [params.content] - 简介（带样式）
 * @param {integer} [params.contentType] - 内容类型
 * @param {integer} [params.deptId] - 部门id
 * @param {string} [params.endCreateTime] - 结束创建时间
 * @param {string} [params.endPushTime] - 结束发布时间
 * @param {string} [params.files] -    文件地址json
 * @param {integer} [params.hits] -    点击量
 * @param {string} [params.publisher] -    发布人
 * @param {integer} [params.status] -    文章状态：0已保存、1已发布、2取消发布
 * @param {string} [params.title] -    标题
 * @param {integer} [params.type] -    文章分类：0新闻信息、1公告信息、2公示信息、3办事指南、4政策法规
 * @returns
 */
// 新闻获取，默认获取10条
export async function getLists(params) {
    return await http.post('/veteran/vs/news/list', params);
}

// 问卷调查
export async function getWjdcLists(params) {
    return await http.post('/veteran/vs/news/project/page', params);
}

// 问卷调查详情
export async function geInvestigationDetail(params) {
    return await http.post('/veteran/vs/news/project/pushurl?' + params);
}

// 右侧浮窗
export async function getBayWin() {
    return await http.post('/veteran/vs/bay-window/list');
}

// 获取个人服务和企业服务菜单
export async function getServicesMenu() {
    return await http.get('/veteran/vs/menu');
}

// 获取友情链接
export async function getFriLinks() {
    return await http.get('/veteran/vs/blogroll');
}

// 分页新闻获取
export async function getPageLists(params) {
    params = { 'field': 'pushTime', 'desc': 0, ...params }
    return await http.post('/veteran/vs/news/page', params);
}

// 获取互动咨询
export async function getConsultLists(params) {
    return await http.post('/veteran/vs/consult/page', params);
}

// 获取详情
export async function getDetail(params) {
    return await http.get('/veteran/vs/news/get/' + params);
}

// 获取培训详情
export async function getVeteranDetail(params) {
    return await http.get('/veteran/vs/veteran-train/get/' + params);
}

// 获取咨询详情
export async function getConsultDetail(params) {
    return await http.get('/veteran/vs/consult/askInfo' + params);
}

// 获取培训信息列表
export async function getVeteranPage(params) {
    return await http.post('/veteran/vs/veteran-train/page', params);
}

// 成绩查询
export async function getAchievement(params) {
    return await http.post('/veteran/vs/getAchievement', params);
}

// 培训信息报名提交
export async function updateTrain(params, id, code) {
    return await http.post('/veteran/vs/veteran-train/save?trainId=' + id + '&code=' + code, params);
}

// 咨询类型列表
export async function getConsultType(params) {
    return await http.post('/veteran/vs/consult/type/list', params);
}

// 咨询内容提交
export async function uploadConsult(params) {
    return await http.post('/veteran/vs/consult/consult-ask', params);
}

// 获取验证码
export async function getCaptcha() {
    return await http.get('/veteran/vs/captcha/get-image');
}

// 验证退役军人是否存在
export async function checkingReportSoldier(params) {
    return await http.post('/veteran/vs/report/verify/info', params);
}

// 获取报到须知
export async function getReportNotice() {
    return await http.post('/veteran/vs/report/notice');
}

// 病故军人抚恤金查询
export async function getPension(params) {
    return await http.post('/veteran/vs/pension/record/verify', params);
}

// 提交抚恤金审核
export async function uploadPension(params) {
    return await http.post('/veteran/vs/pension', params);
}

// 查询抚恤金申请记录
export async function checkingPension(params) {
    return await http.post('/veteran/vs/pension/verify', params);
}

// 发送手机验证码
export async function getSmsCode(params) {
    return await http.post('/veteran/vs/send-sms-code', params);
}

// 提交预约-拥军优属
export async function uploadReserve(params) {
    return await http.post('/veteran/vs/order/v3/reserve', params);
}

// 获取接收函须知
export async function getOfferNotice(params) {
    return await http.get('/veteran/vs/order/offer/notice' + params);
}

// 存档介绍信
export async function uploadArchive(params) {
    return await http.post('/veteran/vs/order/archive', params);
}

// 企业认证审核
export async function uploadEnterprise(params) {
    return await http.post('/veteran/vs/enterprise', params);
}

//获得互动咨询分页
export async function getConsultPage(params) {
    return await http.post('/veteran/vs/consult/page', params);
}

//保存接收函信息
export async function uploadOffer(params) {
    return await http.post('/veteran/vs/order/offer', params);
}

//企业认证登录，获取企业认证信息
export async function getEnterpriseInfo() {
    return await http.get('/info/vs/core/enterprise/info');
}

//获取招聘信息分页
export async function getRecruitmentPage(params) {
    return await http.post('/veteran/vs/resume/recruitment/page', params);
}

//使用手机+验证码登录
export async function smsLogin(params) {
    return await http.post('/veteran/vs/sms-login', params);
}

//获取用户信息
export async function getUserInfo() {
    return await http.get('/veteran/user/info');
}

//修改头像
export async function putAvatar(params) {
    return await http.put('/veteran/user/avatar?url=' + params);
}

//修改用户信息
export async function putUserInfo(params) {
    return await http.put('/veteran/user/info', params);
}

//系统消息，培训信息，调查问卷
export async function getMessagePage(params) {
    return await http.post('/info/vs/core/page', params);
}

//获得培训信息报名分页
export async function getTrainPage(params) {
    return await http.post('/veteransign/vs/veteran-train/page', params);
}

//标记消息已读
export async function messageMarked(params) {
    return await http.post('/info/vs/core/markread', params);
}

//获得我的咨询问题分页
export async function getAskPage(params) {
    return await http.post('/info/vs/core/ask/page', params);
}

//个人中心获得简历基本信息
export async function getResumeInfo() {
    return await http.get('/restrict/vs/resume/userGet');
}

//创建简历基本信息
export async function createResumeInfo(params) {
    return await http.post('/restrict/vs/resume/create', params);
}

//更新简历基本信息
export async function updateResumeInfo(params) {
    return await http.put('/restrict/vs/resume/update', params);
}

//创建教育经历
export async function createEducationInfo(params) {
    return await http.post('/restrict/vs/resume/edu/create', params);
}

//更新培训经历
export async function updateEducationInfo(params) {
    return await http.put('/restrict/vs/resume/edu/update', params);
}

//删除培训经历
export async function deleteEducationInfo(params) {
    return await http.delete('/restrict/vs/resume/edu/delete?id=' + params);
}

//创建工作经历
export async function createWorkInfo(params) {
    return await http.post('/restrict/vs/resume/work/create', params);
}

//更新工作经历
export async function updateWorkInfo(params) {
    return await http.put('/restrict/vs/resume/work/update', params);
}

//删除工作经历
export async function deleteWorkInfo(params) {
    return await http.delete('/restrict/vs/resume/work/delete?id=' + params);
}

//创建培训经历
export async function createTrainInfo(params) {
    return await http.post('/restrict/vs/resume/training/create', params);
}

//更新培训经历
export async function updateTrainInfo(params) {
    return await http.put('/restrict/vs/resume/training/update', params);
}

//删除培训经历
export async function deleteTrainInfo(params) {
    return await http.delete('/restrict/vs/resume/training/delete?id=' + params);
}

//创建语言能力
export async function createLangInfo(params) {
    return await http.post('/restrict/vs/resume/language/create', params);
}

//更新语言经历
export async function updateLangInfo(params) {
    return await http.put('/restrict/vs/resume/language/update', params);
}

//删除语言经历
export async function deleteLangInfo(params) {
    return await http.delete('/restrict/vs/resume/language/delete?id=' + params);
}

//创建证书能力
export async function createObtainInfo(params) {
    return await http.post('/restrict/vs/resume/obtain/create', params);
}

//更新证书经历
export async function updateObtainInfo(params) {
    return await http.put('/restrict/vs/resume/obtain/update', params);
}

//删除证书经历
export async function deleteObtainInfo(params) {
    return await http.delete('/restrict/vs/resume/obtain/delete?id=' + params);
}

//创建招聘信息
export async function createRecruitment(params) {
    return await http.post('/restrict/vs/resume/recruitment/create', params);
}

//更新招聘信息状态
export async function updateRecruitment(params) {
    return await http.put('/restrict/vs/resume/recruitment/update/status', params);
}

//更新招聘信息
export async function updateRecruitmentInfo(params) {
    return await http.put('/restrict/vs/resume/recruitment/update', params);
}

//删除招聘信息
export async function deleteRecruitment(params) {
    return await http.delete('/restrict/vs/resume/recruitment/delete?id=' + params);
}

//获得投递明细分页
export async function getRecruitmentDetailPage(params) {
    return await http.post('/restrict/vs/resume/recruitment/delivery/page', params);
}

//个人中心-获得招聘信息分页
export async function getSpaceRecruitmentPage(params) {
    return await http.post('/restrict/vs/resume/recruitment/page', params);
}

//获得招聘信息详情页
export async function getRecruitmentDetail(params) {
    return await http.get('/veteran/vs/resume/recruitment/get?id=' + params);
}

//创建简历投递记录
export async function createDelivery(params) {
    return await http.post('/veteran/vs/delivery/create', params);
}

//单位获得简历基本信息
export async function unitGetResumeDetail(params) {
    return await http.get('/restrict/vs/resume/unitGet?id=' + params);
}

//获得简历投递记录分页
export async function getDeliveryPage(params) {
    return await http.post('/restrict/vs/delivery/page', params);
}

//获得培训信息报名详情
export async function getTrainDetail(params) {
    return await http.get('/veteransign/vs/veteran-train/get?signItemId=' + params);
}

//获得简历基本信息分页
export async function getResumePage(params) {
    return await http.post('/restrict/vs/resume/page', params);
}

//随军家属业务预约无效数据过滤
export async function updateFamilyFilter(params) {
    return await http.put('/veteran/vs/order/effective?id=' + params);
}

//获取企业认证信息-用于个人中心
export async function updateCompanyInfo(params) {
    return await http.put('/veteran/vt/enterprise/user/withdraw', params);
}

//获取我的预约
export async function getAppointmentList(params) {
    return await http.get('/info/vs/core/report', params);
}

//我的预约服务评价提交
export async function updateAppointment(params) {
    return await http.put('/info/vs/core/report/evaluation?' + params);
}

//我的预约取消预约
export async function cancelAppointment(params) {
    return await http.put('/info/vs/core/report/cancel?' + params);
}

//我的培训取消报名
export async function cancelTrainAppointment(params) {
    return await http.get('/veteransign/vs/veteran-train/cancel?' + params);
}

//获取机加密密钥
export async function getPublicKey() {
    return await http.get('/encryption');
}